export const ProductDisplay: React.FC<{
  product_name: string
  product_sku: string
  image_url?: string
  seller_id?: string | null
}> = ({ product_name, product_sku, image_url, seller_id }) => {
  return (
    <div
      className="border rounded p-2 py-1"
      style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}
    >
      {image_url && (
        <img
          src={image_url}
          alt={product_name}
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            objectFit: 'contain',
            flexShrink: 0
          }}
        />
      )}
      <div style={{ flex: 1 }}>
        <p className="m-0 fs-6">
          <small style={{ lineHeight: '.75rem' }}>{product_name}</small>
          <br />
          <strong>SKU:</strong> {product_sku}
          {seller_id && (
            <>
              <br />
              <strong>Seller ID:</strong> {seller_id}
            </>
          )}
        </p>
      </div>
    </div>
  )
}
